module.exports = __webpack_public_path__ + "img/welcome_17.eda7f36b.jpg";